import React from 'react';

interface AvatarProps {
    label: string;
    color: string;
    src?: string;
    size?: number; // size in tailwind units (e.g., 6 for w-6 h-6)
    className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ label, src, color, size = 6, className }) => {
    const textSize = Math.max(0.5, size * 0.125);
    const dimension = `${size * 0.25}rem`;
    const backgroundColor = color.startsWith('#') ? `${color}22` : color;

    return (
        <div className={`relative ${className || ''}`} style={{ width: dimension, height: dimension }}>
            <div className="absolute inset-0 rounded-full bg-surface"></div>
            <div
                className="absolute inset-0 flex items-center justify-center rounded-full border border-secondary"
                style={{ backgroundColor }}
            >
                {src ? (
                    <img src={src} alt={label} className="rounded-full w-full h-full object-cover" />
                ) : (
                    <span
                        className="font-medium"
                        style={{ color, fontSize: `${textSize}rem` }} // Adjust the text size dynamically
                    >
                        {label}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Avatar;
